import { MuiDialog, MuiDialogTitle, MuiDialogContent } from 'settings/theme-components/dialog';
import { MuiAlert } from './theme-components/alert';
import { MuiButton } from './theme-components/button';
import { MuiPaper } from './theme-components/paper';
import { MuiToggleButtonGroup, MuiToggleButton } from './theme-components/toggle-button';

import * as Inputs from 'settings/theme-components/inputs';

export const components: any = {
  ...Inputs,
  MuiDialog,
  MuiDialogTitle,
  MuiDialogContent,
  MuiAlert,
  MuiButton,
  MuiPaper,
  MuiToggleButtonGroup,
  MuiToggleButton,
};
